import React from "react";
import './index.scss';
import {SimpleTooltip} from "../../../../components/SimpleTooltip";
import checkRoundActive from "../../../../images/check-round-active-red.svg";
import checkRoundInactive from "../../../../images/check-round-plus-green.svg";
import {translit} from "../../../../utils/utils";


export interface AdvertiseOption {
    name: string;
    tooltip?: React.ReactElement | null;
    tooltipPlacement?: "top" | "bottom" | "left" | "right";
    selected: boolean;
    iconType: 'check' | 'plus'
}

export const AdvertiseOption = ({name, tooltip, tooltipPlacement, selected, iconType}: AdvertiseOption) => {
    const optionBlock = <div className='advertise-option__block'>
		<span className='advertise-option__icon'>
						{iconType === 'check' ? (
                            <img src={checkRoundActive} alt=''/>
                        ) : (
                            <img className={'advertise-option__icon_rotate'} src={checkRoundInactive} alt=''/>
                        )}
					</span>

        <span className={`advertise-option__name ${selected ? 'advertise_text-selected' : 'advertise_text-not-selected'}`}>{name}</span>
    </div>;

    return (
        <span className='advertise-option'>
			{tooltip && (
                <SimpleTooltip id={'sales' + translit(name)} title={tooltip} placement={tooltipPlacement}>
                    {optionBlock}
                </SimpleTooltip>
            )}

            {!tooltip && (
                optionBlock
            )}
		</span>
    )

};